module.exports = __webpack_public_path__ + "static/media/MR_hikaru.99cd4c11.png";